(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-validate-voucher-code.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-validate-voucher-code.js');
"use strict";

const {
  useEffect,
  useRef,
  useState
} = React;
const useValidateVoucherCode = _ref => {
  let {
    voucherCode,
    onClose
  } = _ref;
  const [isChecking, setIsChecking] = useState(true);
  const [invalidCode, setInvalidCode] = useState(null);
  const mountedRef = useRef(null);
  useEffect(() => {
    mountedRef.current = true;
    const validateVoucherCode = async () => {
      svs.ui.loader.show();
      try {
        svs.ticketgames.ticketUtility.logger.info('Checking if voucherCode is redeemable..');
        await svs.ticketgames.ticketUtility.utils.getVoucherCode(voucherCode);
        if (mountedRef.current) {
          setIsChecking(false);
          setInvalidCode(false);
        }
        svs.ticketgames.ticketUtility.logger.info('VoucherCode is redeemable..');
      } catch (e) {
        mountedRef.current && setInvalidCode(true);
        svs.ticketgames.ticketUtility.logger.warn("VoucherCode is already claimed or invalid: ".concat(e));
        svs.tur.apierrors.showErrorMessage({
          onConfirm: onClose,
          response: 0
        });
      }
      mountedRef.current && setIsChecking(false);
      svs.ui.loader.hide();
    };
    validateVoucherCode();
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return {
    isChecking,
    invalidCode
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useValidateVoucherCode', useValidateVoucherCode);

 })(window);